import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

const getSystemTheme = () =>
  window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const ThemeProvider = ({ children }) => {
  const [preference, setPreference] = useState(() => localStorage.getItem('theme') || 'system');

  useEffect(() => {
    const apply = () => {
      const resolved = preference === 'system' ? getSystemTheme() : preference;
      document.documentElement.classList.toggle('dark', resolved === 'dark');
    };
    apply();
    if (preference === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [preference]);

  const setTheme = (pref) => {
    setPreference(pref);
    if (pref === 'system') localStorage.removeItem('theme');
    else localStorage.setItem('theme', pref);
  };

  const theme = preference === 'system' ? getSystemTheme() : preference;

  return (
    <ThemeContext.Provider value={{ preference, theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
